import { isNil } from 'lodash';
import React from 'react';

import { getBooleanValue } from '@/shared/booleans';

export const AppFeatures = {
  Apply: 'APPLY_FEATURE',
  Applications: 'APPLICATIONS_FEATURE',
  CookieConsent: 'COOKIE_CONSENT_FEATURE',
  MembershipPreferences: 'MEMBERSHIP_PREFERENCES_FEATURE',
  V3Usage: 'V3_USAGE_FEATURE'
} as const;

type FeatureOptions = {
  enabled?: boolean;
};

export function isFeatureEnabled(featureName: string, options?: FeatureOptions) {
  const envVar = import.meta.env[`VITE_${featureName}`];
  if (!isNil(envVar)) return getBooleanValue(envVar);

  return !!options?.enabled;
}

export function useFeature(featureName: string, options?: FeatureOptions) {
  return React.useMemo(() => {
    return isFeatureEnabled(featureName, options);
  }, [featureName, options]);
}
